<template>
  <div>
    {{msg}}
    <menu-list></menu-list>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
import SidebarOne from '@/base/sidebar1/sidebar1'
export default {
  name: '',
  components: {
    'menu-list': Menu,
    'sidebar-one': SidebarOne
  },
  data () {
    return {
      msg: '阅读卡'
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ReadingCard/readingcard.vue


// WEBPACK FOOTER //
// src/components/ReadingCard/readingcard.vue